import React from 'react';
import { motion } from 'framer-motion';

const ResultCard = ({ title, value, subtitle, color = 'blue', delay = 0 }) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    orange: 'from-orange-500 to-orange-600',
    red: 'from-red-500 to-red-600'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className="bg-white rounded-2xl shadow-xl overflow-hidden"
    >
      <div className={`h-2 bg-gradient-to-r ${colorClasses[color]}`} />
      <div className="p-6">
        <h3 className="text-lg font-semibold text-gray-600 mb-2">
          {title}
        </h3>
        <p className="text-3xl font-bold text-gray-800 mb-1">
          {value}
        </p>
        <p className="text-sm text-gray-500">
          {subtitle}
        </p>
      </div>
    </motion.div>
  );
};

export default ResultCard;